import * as config from './../config/config'
import api from './interceptor'

export async function get_ListeType(){
  try {
    const response = await api.get(config.REACT_APP_ENDPOINT_LIST_TYPE);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export async function updateType(data) {
  try {
    const response = await api.put(config.REACT_APP_ENDPOINT_UPDATE_TYPE + '/' + data['id'], {
      "nom" : data['nom']
    })
    return response.data
  } catch (error) {
    throw(error)
  }
}

export async function createType(data) {
  try{
    const response = await api.post(config.REACT_APP_ENDPOINT_CREATE_TYPE, {
      "id" : data['id'],
      "nom" : data['nom']
    })
    return response.data
  } catch(error) {
    throw(error)
  }
}

export async function deleteType(data) {
  try{
    const response = await api.delete(config.REACT_APP_ENDPOINT_DELETE_TYPE + '/' + data['id'])
    return response.data
  } catch (error) {
    throw (error)
  }
}